import React from "react"

import { AppCardTitle, AppCrudTable } from "@components"
import { userSettingSitesData } from "../../../@signals"
import { actionsColumn, colorColumn, nameColumn } from "./columns"
import { isTourDemoActive } from "@signals/app"
import UserSettingsSitesTabButton from "../Button"

export default function UserSettingsColorSitesTable() {
	if (isTourDemoActive.value && !userSettingSitesData.value?.length) return null
	return <AppCrudTable
		// The tab's create button with the table's own actions, as every list of the app
		options={{ customToolbar: () => <UserSettingsSitesTabButton/> }}
		title={<AppCardTitle icon="palette" title="Site Colors"/>}
		data={userSettingSitesData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}